import React, { useCallback } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useMetric from '../../lib/hooks/useMetric';
import { AdminProgressBar } from '../AdminProgressBar';

const useStyles = makeStyles((theme) => ({
  card: {
    cursor: 'pointer',
    width: 214,
    height: 100,
    marginRight: 25,
    marginBottom: 25,
    '& h3': {
      fontSize: 28,
      textAlign: 'center',
      fontWeight: 'bold',
      color: theme.palette.admin.main,
    },
    '& h5': {
      fontSize: 13,
      textAlign: 'center',
      display: 'block',
      fontWeight: 'bold',
      color: theme.palette.common.grey['500'],
    },
  },
}));
const MetricCard = ({ slug }) => {
  const classes = useStyles();
  const { isLoading, isRefetching, data, refetch } = slug ? useMetric(slug) : false;
  const { title, value } = data ?? '';
  const refreshMetric = useCallback(() => refetch(), []);

  return (
    <Card
      className={classes.card}
      onClick={refreshMetric}
    >
      <CardContent>
        {isLoading || isRefetching ? (
          <AdminProgressBar style={{ marginTop: 33 }} />
        ) : (
          <>
            <Typography variant={'h3'}>{value}</Typography>
            <Typography variant={'h5'}>{title}</Typography>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default MetricCard;
